import React from 'react';

import { Svg, SvgPath, SvgProps, registerSVG } from '@rbilabs/universal-components';
import { Rect } from 'react-native-svg';

export function BkUpsellPlus(props: SvgProps) {
  return (
    <Svg {...props} viewBox="0 0 30 31" fill="none">
      <Rect x={0} y={0} width={30} height={30} rx={15} fill="#D62300" />
      <SvgPath
        d="M19.0833 16.5605H15.5833V20.0604H14.4167V16.5605H10.9167V15.3938H14.4167V11.8938H15.5833V15.3938H19.0833V16.5605Z"
        fill="white"
      />
    </Svg>
  );
}

registerSVG('BkUpsellPlus', BkUpsellPlus);
